<mat-form-field class="full-width">

  <mat-label class="{{labelClass}}" >{{label}}</mat-label>
  <mat-select  [matTooltip]="toolTip" matTooltipClass="ttformat" [placeholder]="placeHolder" [formControl]="formCtrl">
    
      <mat-option *ngFor="let opt of options" [value]="opt.key">
          {{opt.value}}
      </mat-option>
  </mat-select>
  <button type="button"   *ngIf="formCtrl.value!==''" matSuffix
      aria-label="Clear" [hidden]="disableClearBtn" 
      (click)="clearControl()">
      <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="formCtrl.errors">{{errormessage}}</mat-error>
</mat-form-field>
